import { IActiveDiscountDetail, IAddItemBase, IDiscountDetail, IPointsVerifyResponse } from "@interfaces";
import ftPublicApiClient from "./ftPublicApiClient";
import { AxiosResponse } from "axios";
import ftApiClient from "./ftApiClient";

export const discountApi = {
    getActiveDiscount: (isAuthenticated: boolean) => {
        const url = "/discount/active";
        const client = isAuthenticated ? ftApiClient : ftPublicApiClient;
        return client.get<AxiosResponse<IActiveDiscountDetail>>(url);
    },
    getCartDiscount: () => {
        const url = "/cart/discount/v2?isCart=1";
        return ftApiClient.post<AxiosResponse<IDiscountDetail>>(url).then((res) => {
            console.log("[DEBUG] CART DISCOUNT response:", JSON.stringify(res.data, null, 2));
            return res;
        });
    },
    getQuoteDiscount: (quoteId: string) => {
        const url = "/cart/discount/v2?quoteId=" + quoteId;
        return ftApiClient.post<AxiosResponse<IDiscountDetail>>(url).then((res) => {
            console.log("[DEBUG] QUOTE DISCOUNT response (quoteId=" + quoteId + "):", JSON.stringify(res.data, null, 2));
            return res;
        });
    },
    checkOrderDiscount: (items: IAddItemBase[], sessionId?: string) => {
        const url = sessionId
            ? `/cart/discount/v2?sessionId=${sessionId}`
            : "/cart/discount/v2?dry=1";
        const client = sessionId ? ftPublicApiClient : ftApiClient;
        return client.post<AxiosResponse<IDiscountDetail>>(url, items).then((res) => {
            console.log("[DEBUG] CHECK ORDER DISCOUNT response:", JSON.stringify(res.data, null, 2));
            return res;
        });
    },
    verifyCartPoints: (cachedPointsAvailable: number) => {
        const url = "/cart/points/verify?isCart=1";
        return ftApiClient.post<AxiosResponse<IPointsVerifyResponse>>(url, { cachedPointsAvailable }).then((res) => {
            console.log("[DEBUG] VERIFY CART POINTS response:", JSON.stringify(res.data, null, 2));
            return res;
        });
    },
    verifyQuotePoints: (quoteId: string, cachedPointsAvailable: number) => {
        const url = `/cart/points/verify?quoteId=${quoteId}`;
        return ftApiClient.post<AxiosResponse<IPointsVerifyResponse>>(url, { cachedPointsAvailable }).then((res) => {
            console.log("[DEBUG] VERIFY QUOTE POINTS response (quoteId=" + quoteId + "):", JSON.stringify(res.data, null, 2));
            return res;
        });
    },
};
